import moment from 'moment';

export type PeriodName =
  | 'current month'
  | 'previous month'
  | 'current year'
  | 'previous year'
  | 'custom';

const startOfMonth = moment.utc().startOf('month');
const endOfMonth = moment.utc().endOf('month');
const startOfPreviousMonth = startOfMonth.clone().subtract(1, 'month');
const endOfPreviousMonth = startOfPreviousMonth.clone().endOf('month');

const fiscalYearStartMonth = 3;
const isStarOfFiscalYearThisYear = moment.utc().month() >= fiscalYearStartMonth;

const startOfFiscalYear = isStarOfFiscalYearThisYear
  ? moment.utc().month(fiscalYearStartMonth).startOf('month')
  : moment
      .utc()
      .subtract(1, 'year')
      .month(fiscalYearStartMonth)
      .startOf('month');

const endOfFiscalYear = isStarOfFiscalYearThisYear
  ? moment
      .utc()
      .add(1, 'year')
      .month(fiscalYearStartMonth - 1)
      .endOf('month')
  : moment.utc().month(fiscalYearStartMonth).endOf('month');

const startOfPreviousFiscalYear = startOfFiscalYear.clone().subtract(1, 'year');
const endOfPreviousFiscalYear = endOfFiscalYear.clone().subtract(1, 'year');

export const periodDatesByName: Partial<Record<PeriodName, [Date, Date]>> = {
  'current month': [startOfMonth.toDate(), endOfMonth.toDate()],
  'previous month': [
    startOfPreviousMonth.toDate(),
    endOfPreviousMonth.toDate(),
  ],
  'current year': [startOfFiscalYear.toDate(), endOfFiscalYear.toDate()],
  'previous year': [
    startOfPreviousFiscalYear.toDate(),
    endOfPreviousFiscalYear.toDate(),
  ],
};
